import * as urlQueryString from './../../urlQueryString';
import * as constants from './../../constants';

/**
 * @param {string} selectedOwner
 * @param {Immutable.Record} user
 * @returns {Object}
 */
export const getSelectedOwnerForRootCause = ({ name: selectedOwner } = {}, user) => {
  if (selectedOwner === 'team') {
    return {
      ownerType: 'team',
      username: user.getUserTeamId(),
    };
  }

  if (selectedOwner === 'organization') {
    return {
      ownerType: 'org',
      username: user.get('organization').id,
    };
  }

  return {
    ownerType: 'user',
    username: user.get('username'),
  };
};

/**
 * @param {Object} location
 * @param {Immutable.Record} user
 * @returns {Object}
 */
export const getOwnerFromQueryStringForRootCause = (location, user) => {
  const ownersQueryString = urlQueryString.get(location, constants.ROOTCAUSE_QUERY_STRINGS.OWNERS);
  const userQueryString = urlQueryString.get(location, constants.ROOTCAUSE_QUERY_STRINGS.USER);

  if (!userQueryString && !ownersQueryString) {
    return null;
  }

  if (userQueryString) {
    return {
      ownerType: 'user',
      username: userQueryString,
    };
  }

  return getSelectedOwnerForRootCause({ name: ownersQueryString }, user);
};
